import Api from './Api'

class Organization extends Api {

  constructor(version = 'v1') {
    super(version)
    this.path = 'organizations'
  }

  getAll(enforceAllstatuses='false', enforceArchived='false', sortBy='name', disablePagination='true') {
    return new Promise((resolve, reject) => {
      this.http
        .get(`/organizations?representer=full&sort_by=${sortBy}&disable_pagination=${disablePagination}&enforce_all_statuses=${enforceAllstatuses}&enforce_archived=${enforceArchived}`)
        .then(response => {
          resolve(response.data.resources);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  projects_crm_sync(organization_id) {
    return new Promise((resolve, reject) => {
      this.http.put('/organizations/' + organization_id + '/enqueue_crm_sync').then(response => {
        resolve(response.data)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    });
  }

  projectsList(organizationId, params) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`/organizations/${organizationId}/projects`, {
          params: {
            search: params['search'],
            per_page: 10
          }
        })
        .then(response => {
          resolve(response.data.resources);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  companiesList(organizationId, params) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`/organizations/${organizationId}/companies`, {
          params: {
            search: params['search'],
            per_page: 10
          }
        })
        .then(response => {
          resolve(response.data.resources);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  configuration(organization_id, params={}){
    return new Promise((resolve, reject) => {
      this.http.get('/organizations/' + organization_id + '/organization_configurations', {params}).then(response => {
        resolve(response.data.resources)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    });
  }

  crm(organization_id, params={}){
    return new Promise((resolve, reject) => {
      this.http.get('/organizations/' + organization_id + '/crm', {params}).then(response => {
        resolve(response.data.resource)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    });
  }

  update_configuration(organization_id, configuration){
    let configuration_collection = []

    Object.entries(configuration).forEach(([key, val]) => {
      configuration_collection.push(
        {key: key,
        content: val['content'],
        configuration_type: val['configuration_type']}
      )
    })
    return new Promise((resolve, reject) => {
      this.http.put('/organizations/' + organization_id + '/organization_configurations/create_or_update_multiple', {configurations: configuration_collection}).then(response => {
        resolve(response.data)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    });
  }

}

export default Organization



// WEBPACK FOOTER //
// ./src/api/Organization.js